import { memo } from 'react';
import { useServices } from 'core/common/hooks';
import { ModalHeader } from 'core/common/ui/ui-kit';
import PaymentThreeDomainSecure from '../PaymentThreeDomainSecure';
import { ModalStyled } from './styled';

type PaymentThreeDomainSecureDialogProps = {
  isOpen?: boolean;
  onClose?: () => void;
  onSucceed?: () => void;
};

const PaymentThreeDomainSecureDialog = ({
  isOpen = false,
  onSucceed,
  onClose,
}: PaymentThreeDomainSecureDialogProps) => {
  const { analyticsService } = useServices();

  const close = () => {
    analyticsService.trackEvent('funnel_modal_click', { screen_context: '3ds', value: 'close' });

    if (onClose) {
      onClose();
    }
  };

  return (
    <ModalStyled open={isOpen}>
      <>
        <ModalHeader onClose={close} />
        <PaymentThreeDomainSecure onSucceed={onSucceed} />
      </>
    </ModalStyled>
  );
};

export default memo(PaymentThreeDomainSecureDialog);
